import { useSelector } from 'react-redux'
import { Type } from '../../../../types/Controlling/Offer'
import { formatEUR } from '../../../../utility'
import props from '../../../../redux/props'
import { OfferEntry } from '../../../../types/Controlling/OfferEntry'

type Props = {
  entries: OfferEntry[]
  previousYearEntries: OfferEntry[]
}

const Facts: React.FC<Props> = ({ entries, previousYearEntries }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getTotalIncome = (entries: OfferEntry[]) => {
    return entries.reduce((acc, entry) => {
      return entry.offer.type === Type.INCOME ? acc + entry.amount : acc
    }, 0)
  }

  const getTotalExpense = (entries: OfferEntry[]) => {
    return entries.reduce((acc, entry) => {
      return entry.offer.type === Type.EXPENSE ? acc + entry.amount : acc
    }, 0)
  }

  const getYearForecast = (entries: OfferEntry[]) => {
    return getTotalIncome(entries) - getTotalExpense(entries)
  }

  const getYearComparison = () => {
    const currentYear = getYearForecast(entries) || 0
    const previousYear = getYearForecast(previousYearEntries) || 0

    if (currentYear > previousYear) {
      if (previousYear === 0) return 100
      return Math.round(100 - (100 / currentYear) * previousYear)
    } else if (currentYear < previousYear) {
      if (currentYear === 0) return -100
      return -Math.round(100 - (100 / previousYear) * currentYear)
    } else {
      return 0
    }
  }

  return (
    <div className="flex gap-5">
      <div className="w-full bg-white shadow-md p-3">
        <div className="font-bold">{t.controlling.forecast.income}</div>
        <div className="font-bold text-xl text-center text-green">{formatEUR(getTotalIncome(entries))}</div>
      </div>
      <div className="w-full bg-white shadow-md p-3">
        <div className="font-bold">{t.controlling.forecast.expense}</div>
        <div className="font-bold text-xl text-center text-red">{formatEUR(getTotalExpense(entries))}</div>
      </div>
      <div className="w-full bg-white shadow-md p-3">
        <div className="font-bold">{t.controlling.forecast.yearForecast}</div>
        <div className={`font-bold text-xl text-center ${getYearForecast(entries) > 0 ? 'text-green' : 'text-red'}`}>
          {formatEUR(getYearForecast(entries))}
        </div>
      </div>
      <div className="w-full bg-white shadow-md p-3">
        <div className="font-bold">{t.controlling.forecast.yearComparison}</div>
        <div className={`font-bold text-xl text-center ${getYearComparison() > 0 ? 'text-green' : 'text-red'}`}>
          {getYearComparison() + t.generic.percentageSuffix}
        </div>
      </div>
    </div>
  )
}

export default Facts
